import { useEffect, useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { ASSISTANTS, ASSISTANT_CHANGED_EVENT, ADMIN_ASSISTANT_PREVIEW_KEY, NO_ASSISTANT } from "@/lib/assistants";

/** Solo administrador: ver el panel con otro asistente sin tocar su perfil. */
export default function AdminAssistantSwitcher() {
  const { lang } = useLanguage();
  const es = lang === "es";
  const [val, setVal] = useState("");
  useEffect(() => { setVal(sessionStorage.getItem(ADMIN_ASSISTANT_PREVIEW_KEY) ?? ""); }, []);
  const change = (v: string) => {
    setVal(v);
    if (v) sessionStorage.setItem(ADMIN_ASSISTANT_PREVIEW_KEY, v); else sessionStorage.removeItem(ADMIN_ASSISTANT_PREVIEW_KEY);
    window.dispatchEvent(new Event(ASSISTANT_CHANGED_EVENT));
  };
  return (
    <select value={val} onChange={(e) => change(e.target.value)} aria-label={es ? "Ver con otro asistente" : "Preview another assistant"}
      className="h-9 shrink-0 rounded-full border border-border bg-card px-3 text-xs text-foreground">
      <option value="">{es ? "Avatar: el mío" : "Avatar: mine"}</option>
      <option value={NO_ASSISTANT}>{es ? "Avatar: sin dibujo" : "Avatar: no drawing"}</option>
      {ASSISTANTS.map((a) => <option key={a.id} value={a.id}>{`Avatar: ${a.name}`}</option>)}
    </select>
  );
}
